import React, { Component } from 'react'
import { Tag, Popover } from 'antd'
import { messageTypes } from '../../actions/messages'

class StyledStatusDisplay extends Component {
  constructor (props) {
    super(props)
    this.state = {
      color: '',
      text: '',
      status: undefined
    }
  }

  componentDidMount () {
    this.describeButton(this.props.status)
  }

  componentDidUpdate (prevProps, prevState) {
    const { status } = this.props
    if (prevProps.status !== status) {
      this.describeButton(status)
    }
  }

  describeButton = (status) => {
    let color = ''
    let text = ''
    const { language } = this.props

    if (status === 'poweredOn') {
      color = 'green'
      text = messageTypes[language].status_poweredOn
    } else if (status === 'poweredOff') {
      color = 'red'
      text = messageTypes[language].status_poweredOff
    } else if (status === 'err' || status === 'failed') {
      color = 'red'
      text = messageTypes[language].status_err
    } else if (status === 'turning_on' || status === 'poweringon') {
      color = 'yellow'
      text = messageTypes[language].status_turning_on
    } else if (status === 'turning_off') {
      color = 'yellow'
      text = messageTypes[language].status_turning_off
    } else if (status === 'rebooting') {
      color = 'yellow'
      text = messageTypes[language].status_rebooting
    } else if (status === 'reverting') {
      color = 'yellow'
      text = messageTypes[language].status_reverting
    } else if (status === 'logging') {
      color = 'yellow'
      text = messageTypes[language].status_logging
    } else if (status === 'testing') {
      color = 'yellow'
      text = messageTypes[language].status_testing
    } else if (status === 'suspended') {
      color = 'red'
      text = messageTypes[language].status_suspended
    } else if (status === 'suspending') {
      color = 'yellow'
      text = messageTypes[language].status_suspending
    } else if (/^waiting-for-/.test(status)) {
      color = 'yellow'
      text = messageTypes[language].status_waiting
    } else {
      color = 'yellow'
      text = status
    }

    this.setState({
      color, text, status
    })
  }

  render () {
    const { status } = this.state
    const { language } = this.props
    const statusTag = (<Tag color={this.state.color}>{this.state.text}</Tag>)

    return (
      (status === 'failed' && <Popover content={messageTypes[language].stack_status_failed_explain} placement='bottom'>{statusTag}</Popover>) || statusTag
    )
  }
}

export default StyledStatusDisplay
